import { createSlice } from '@reduxjs/toolkit'
import { CoinList } from './CoinList'

const initialState = {
   conversions: CoinList,
   watchlist: [
      {
         from: {
            name: 'Binance Coin',
            unit: 'BNB',
            change: -10.23,
            image: 'https://via.placeholder.com/32',
         },
         to: {
            name: 'TetherUS',
            unit: 'USDT',
            change: 4.04,
            image: 'https://via.placeholder.com/32',
         },
         value: 281.71,
      },
   ],
}

export const conversionsSlice = createSlice({
   name: 'conversions',
   initialState,
   reducers: {
      addToWatchlist: (state, action) => {
         console.log(action.payload)
         state.watchlist = [...state.watchlist, action.payload]
      },
      removeFromWatchlist: (state, action) => {
         state.watchlist = state.watchlist.filter(
            conv =>
               !(
                  conv.to.unit === action.payload.conversion.to.unit &&
                  conv.from.unit === action.payload.conversion.from.unit
               )
         )
      },
      updateConversionPrices: (state, action) => {
         state.conversions = action.payload
      },
      updateWatchList: (state, action) => {
         state.watchlist = action.payload
      }
   },
})

export const { addToWatchlist, removeFromWatchlist, updateConversionPrices, updateWatchList } = conversionsSlice.actions

export default conversionsSlice.reducer
